var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.682782 31.9294H0V36.3011H4.70244V35.6313H0.682782V31.9294ZM31.3172 31.9294V35.6313H27.2976V36.3011H32V31.9294H31.3172ZM0.000590831 12.8318H0.683373V9.13071H4.70303V8.46094H0.000590831V12.8318ZM27.2976 8.46097V9.13074H31.3172V12.8318H32V8.46097H27.2976Z",
    fill: "#89C0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53711 30.2987H25.8048V0.993164H6.53711V30.2987Z",
    fill: "#97B1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7124 30.2987H25.805V0.993164H16.7124V30.2987Z",
    fill: "#648AEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6509 9.93451H12.3828V5.21582H10.6509V9.93451Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6509 28.8085H12.3828V24.0898H10.6509V28.8085Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7122 11.7969C16.7122 11.8329 14.4341 11.8617 11.6249 11.8617C8.81464 11.8617 6.53711 11.8329 6.53711 11.7969C6.53711 11.7614 8.81464 11.7323 11.6249 11.7323C14.4341 11.7323 16.7122 11.7614 16.7122 11.7969Z",
    fill: "#FFFFFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6509 19.371H12.3828V14.6523H10.6509V19.371Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7122 21.2344C16.7122 21.2704 14.4341 21.2992 11.6249 21.2992C8.81464 21.2992 6.53711 21.2704 6.53711 21.2344C6.53711 21.1989 8.81464 21.1698 11.6249 21.1698C14.4341 21.1698 16.7122 21.1989 16.7122 21.2344Z",
    fill: "#FFFFFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6616 9.93451H20.3935V5.21582H18.6616V9.93451Z",
    fill: "#97B1F1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5581 9.93451H24.29V5.21582H22.5581V9.93451Z",
    fill: "#97B1F1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6616 19.123H20.3935V14.4043H18.6616V19.123Z",
    fill: "#97B1F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5581 19.123H24.29V14.4043H22.5581V19.123Z",
    fill: "#97B1F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6616 28.3124H20.3935V23.5938H18.6616V28.3124Z",
    fill: "#97B1F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5581 28.3124H24.29V23.5938H22.5581V28.3124Z",
    fill: "#97B1F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02246 0.993409H27.321V0H5.02246V0.993409Z",
    fill: "#648AEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 32.5,
    r: 6.5,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 26C25.9093 26 23 28.9093 23 32.5C23 36.0907 25.9093 39 29.5 39C33.0907 39 36 36.0907 36 32.5C36 28.9093 33.0907 26 29.5 26ZM33.2742 33.2339C33.2742 33.4069 33.1327 33.5484 32.9597 33.5484H30.5484V35.9597C30.5484 36.1327 30.4069 36.2742 30.2339 36.2742H28.7661C28.5931 36.2742 28.4516 36.1327 28.4516 35.9597V33.5484H26.0403C25.8673 33.5484 25.7258 33.4069 25.7258 33.2339V31.7661C25.7258 31.5931 25.8673 31.4516 26.0403 31.4516H28.4516V29.0403C28.4516 28.8673 28.5931 28.7258 28.7661 28.7258H30.2339C30.4069 28.7258 30.5484 28.8673 30.5484 29.0403V31.4516H32.9597C33.1327 31.4516 33.2742 31.5931 33.2742 31.7661V33.2339Z",
    fill: "#3063E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.d412da5053fba3a25d01037186aa9871.svg";
export { ForwardRef as ReactComponent };